import { React, useRef } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';

export default function PrintInput(props) {
  const { value, setValue } = props;
  const { t } = useLanguage();

  const InputRef = useRef();

  function onChangeInput(e) {
    const curValue = e.target.value
		const newValue = curValue.replace(/[^0-9]/g, '')

		setValue(newValue);
  }

  function onFocusInput() {
    InputRef.current.style.border = `1px solid #FF8B48`;
  }

  function onBlurInput() {
    InputRef.current.style.border = `1px solid #DFDFDF`;
  }

  return (
    <TopLevelWrapper>
      <LayerWrapper>
        <Input 
          ref={InputRef}
          placeholder='0'
          value={value || ''}
          // disabled={disabled}
          onFocus={onFocusInput}
          onChange={onChangeInput}
          onBlur={onBlurInput}/>
      </LayerWrapper>
      <LayerWrapper>
        <Text>{t('settingProduct.currencyUnit')}</Text>
      </LayerWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  gap: 8px;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const Input = styled.input`
  // width: 61px;
  width: 180px;
  height: 30px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  // margin: 0 8px 0 0;
  padding: 0 0 0 8px;

  border: 1px solid ${props => props.theme.buttonStroke};
  border-radius: 8px;
  outline: none;

  color: ${props => props.theme.text};
  background-color: ${props => props.disabled ? props.theme.buttonFill : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  ::placeholder {
    color: ${props => props.theme.gray};
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 8px 0 0;
`;
